// @flow

// FIXME энумы должны быть энумами(юнионами), а переводы вынесены в отдельные функции

export { businessDayTypeEnum, businessDayTypes } from './businessDay';
export {
  driverQualificationEnum,
  driverQualifications
} from './driverQualification';
export { fuelGroupEnum, fuelGroups } from './fuelGroup';
export {
  fuelsAndGazEnum,
  fuelsAndGazTypes, fuelTypeEnum,
  fuelTypes,
  fuelTypesCalculation
} from './fuelType';
export { operatingModeEnum, operatingModes } from './operatingMode';
export { osagoTransportType } from './osagoBranchTypes';
export { serviceTypeEnum, serviceTypes } from './serviceTypes';
export { tariffTypeEnum, tariffTypes } from './tariffType';
export { accessTypeEnum, accessTypes } from './userAccess';
export {
  avtokranTypes, gpmVehicleTypes, lulechnikVehicleTypes, oldVehicleTypeEnum, oldVehicleTypes, riggerVehicleTypes, safetyCarLiftTypes, trailerVehicleTypes, vehicleGroupEnum, vehicleGroups, vehicleTypeEnum,
  vehicleTypes
} from './vehicleTypes';

export const expenseDirectionDisplayRuleType = {
  earlierMonth: 'месяц раньше',
  currentMonth: 'текущий месяц',
  laterMonth: 'месяц позже',
};

export const expenseDirectionDisplayRuleTypeEnum = {
  earlierMonth: 'earlierMonth',
  currentMonth: 'currentMonth',
  laterMonth: 'laterMonth',
};

export const selfVehiclePlanVehicleTypeEnum = {
  all: 'all',
  kilometrage: 'kilometrage',
  workHours: 'workHours',
};

export const calculationStatus = {
  draft: 'Черновик',
  calculationDone: 'Рассчитан',
};

export const calculationStatusEnum = {
  draft: 'draft',
  calculationDone: 'calculationDone',
};

export const passTypeEnum = {
  springRoad: 'springRoad',
  cargo: 'cargo',
};

export const vehicleTariffEnum = {
  byBrand: 'byBrand',
  byType: 'byType',
};

export const contractVehicleType = {
  fixed: 'Закрепленное',
  fixedPlan: 'Закрепленное (план)',
  oneOff: 'Разовые',
  oneOffPlan: 'Разовые (план)',
  substitution: 'Подмена',
  indefined: 'Неопределен',
  byOrder: 'По заявкам',
};

export const contractVehicleTypeEnum = {
  fixed: 'fixed',
  fixedPlan: 'fixedPlan',
  oneOff: 'oneOff',
  oneOffPlan: 'oneOffPlan',
  substitution: 'substitution',
  indefined: 'indefined',
  byOrder: 'byOrder',
};

// ед. измерения для прейскуранта ГСМ
export const measureTypeFuelPrice = {
  liter: 'Литр',
  kilogram: 'Килограмм',
};

// статус тарифа для НТС
export const vehicleTariffStatus = {
  draft: 'Черновик',
  approved: 'Утверждённый',
  deactivated: 'Деактивированный',
}

export const vehicleTariffStatusEnum = {
  draft: 'draft',
  approved: 'approved',
  deactivated: 'deactivated',
}

const { deactivated, ...newVehicleTariffStatus } = vehicleTariffStatus;
const { deactivated: _, ...newVehicleTariffStatusEnum } = vehicleTariffStatusEnum;

export const vehicleTariffStatusWithoutDeactivated = newVehicleTariffStatus;
export const vehicleTariffStatusEnumWithoutDeactivated = newVehicleTariffStatusEnum;

// тип тарифа для прейскуранта ГСМ
export const rateType = {
  fact: 'Фактический',
  planned: 'Планируемый',
};

export const rateTypeEnum = {
  fact: 'fact',
  planned: 'planned',
};

export const maintenanceDocumentTypeEnum = {
  defectiveStatement: 'defectiveStatement',
  detailedDefectiveStatement: 'detailedDefectiveStatement',
  os3: 'os3',
};

export const contractDocumentType = {
  contract: 'Договор',
  account: 'Лицевой счет',
};
export const contractDocumentTypeEnum = {
  contract: 'contract',
  account: 'account',
};

// Общие статусы по возможности юзаем их
export const entityStatus = {
  created: 'Черновик',
  approvement: 'На согласовании',
  approved: 'Утвержден',
  declined: 'Отклонен',
  editing: 'На редактирование',
  processing: 'Обработка',
  closed: 'Закрыт',
  approvementAfterCognos: 'Не соответствует данным ИСУ',
  approvedAfterCognos: 'Бюджет утвержден в ИСУ',
};
export const entityStatusEnum = {
  created: 'created',
  approvement: 'approvement',
  approved: 'approved',
  declined: 'declined',
  editing: 'editing',
  processing: 'processing',
  closed: 'closed',
  approvementAfterCognos: 'approvementAfterCognos',
  approvedAfterCognos: 'approvedAfterCognos',
};

export const newEntityStatuses = {
  created: 'Создана',
  approvement: 'На утверждении',
  approved: 'Утверждена',
  declined: 'Не утверждена',
};

// Статусы для перечня ТС
export const vehiclePlanStatus = {
  created: 'Сформирован перечень ТС',
  approvement: 'На согласовании',
  listApproved: 'Утверждён перечень ТС',
  declined: 'Отклонен',
  budgetCreated: 'Сформировано предложение',
  approved: 'Утвержден бюджет стс',
  approvementAfterCognos: 'Не соответствует данным ИСУ',
  approvedAfterCognos: 'Бюджет утвержден в ИСУ',
  listEditing: 'Редактирование перечня ТС',
};
export const vehiclePlanStatusEnum = {
  created: 'created',
  approvement: 'approvement',
  listApproved: 'listApproved',
  declined: 'declined',
  budgetCreated: 'budgetCreated',
  approved: 'approved',
  approvementAfterCognos: 'approvementAfterCognos',
  approvedAfterCognos: 'approvedAfterCognos',
  listEditing: 'listEditing',
};

export const contractVehiclePlanStatus = {
  ...entityStatus,
  approvementAfterCognos: 'Не соответствует данным ИСУ',
  approvedAfterCognos: 'Бюджет утвержден в ИСУ',
};

export const contractVehiclePlanStatusEnum = {
  ...entityStatusEnum,
  approvementAfterCognos: 'approvementAfterCognos',
  approvedAfterCognos: 'approvedAfterCognos',
};

export const actStatus = {
  created: 'Создан',
  signed: 'На согласовании',
  approved: 'Согласован',
  workedOut: 'Отработан',
};
export const actStatusEnum = {
  created: 'created',
  signed: 'signed',
  approved: 'approved',
  workedOut: 'workedOut',
};

export const maintenanceMatrixValidAction = {
  required: 'Обязательно',
  allowed: 'Доступно',
  notAllowed: 'Не доступно',
};

export const maintenanceMatrixValidActionEnum = {
  required: 'required',
  allowed: 'allowed',
  notAllowed: 'notAllowed',
};

export const positions = {
  none: 'Отсутствует',
  safetyTechnician:
    'Специалист, ответственный за безопасное производство работ с применением автокрана (крана-манипулятора)',
  rigger: 'Стропальщик',
  mechanic: 'Механик',
  dispatcher: 'Диспетчер',
  engineer: 'Главный инженер',
  medic: 'Медицинский работник',
  lulechnik: 'Рабочий люльки',
  gpmController: 'Специалист, ответственный за содержание ПС в работоспособном состоянии',
  truckCranesMachinist: 'Машинист крана(крановщик)',
  carLiftOperator: 'Машинист подъемника(вышки)',
  manipulatorCranesOperator: 'Оператор(машинист) крана-манипулятора',
  safetyCarLift: 'Специалист, ответственный за безопасное производство работ с применением подъёмников (вышек)',
  driver: 'Водитель',
};

export const thirdPartyPositions = {
  safetyTechnician:
    'Специалист, ответственный за безопасное производство работ с применением автокрана (крана-манипулятора)',
  rigger: 'Стропальщик',
  lulechnik: 'Рабочий люльки',
  manipulatorCranesOperator: 'Оператор(машинист) крана-манипулятора',
  safetyCarLift: 'Специалист, ответственный за безопасное производство работ с применением подъёмников (вышек)',
  thirdPartyApplicant: 'Заявитель сторонней организации',
};

export const positionEnum = {
  none: 'none',
  safetyTechnician: 'safetyTechnician',
  rigger: 'rigger',
  mechanic: 'mechanic',
  engineer: 'engineer',
  dispatcher: 'dispatcher',
  medic: 'medic',
  lulechnik: 'lulechnik',
  gpmController: 'gpmController',
  truckCranesMachinist: 'truckCranesMachinist',
  carLiftOperator: 'carLiftOperator',
  manipulatorCranesOperator: 'manipulatorCranesOperator',
  safetyCarLift: 'safetyCarLift',
  thirdPartyApplicant: 'thirdPartyApplicant'
};

export const orgUnitTypes = {
  branch: 'Филиал',
  service: 'Служба',
};

export const orgUnitTypesEnum = {
  branch: 'branch',
  service: 'service',
};

export const vehicleInventoryStatuses = {
  notAccepted: 'Не принято',
  accepted: 'Принято',
  dropped: 'Выбыло',
  canned: 'Законсервировано',
};

export const vehicleInventoryStatusesEnum = {
  notAccepted: 'notAccepted',
  accepted: 'accepted',
  dropped: 'dropped',
  canned: 'canned',
};

export const vehicleStatuses = {
  draft: 'Черновик',
  working: 'В работе',
  sendingToParus: 'Отправка в Парус',
  limitExceed: 'Превышен лимит',
  onRepair: 'На ремонте',
  isArchive: 'Списано/Архив',
  onAgreeing: 'На согласовании',
  blocked: 'Заблокировано',
};

export const vehicleStatusEnum = {
  draft: 'draft',
  working: 'working',
  sendingToParus: 'sendingToParus',
  limitExceed: 'limitExceed',
  onRepair: 'onRepair',
  isArchive: 'isArchive',
  onAgreeing: 'onAgreeing',
  blocked: 'blocked',
};

export const budgetAnalysisTypes = {
  externalAct: 'Внешний акт',
  writeOffAct: 'Акт списания МПЗ',
  fuelsAct: 'Акт списания топлива',
  oilsAct: 'Акт списания масел',
  maintenance: 'Карточка работ',
};

export const budgetAnalysisTypesEnum = {
  externalAct: 'externalAct',
  writeOffAct: 'writeOffAct',
  fuelsAct: 'fuelsAct',
  oilsAct: 'oilsAct',
  maintenance: 'maintenance',
};

/**
 * Типы сущностей для журнала
 */
export const entityTypes = {
  order: 'Заявка',
  vehicle: 'ТС',
  trip: 'Путевой лист',
  contractVehicle: 'Наемный ТС',
  brand: 'Марка ТС',
  vehicleModel: 'Модель ТС',
  employee: 'Сотрудник',
  tire: 'Шина',
  battery: 'Аккумулятор',
  regulation: 'Регламент',
  contractVehiclePlan: 'Перечень НТС',
  assignment: 'Закрепление НТС',
  contractVehicleBudget: 'Бюджет НТС',
};

export const entityTypesEnum = {
  order: 'order',
  vehicle: 'vehicle',
  trip: 'trip',
  contractVehicle: 'contractVehicle',
  brand: 'brand',
  vehicleModel: 'vehicleModel',
  employee: 'employee',
  tire: 'tire',
  battery: 'battery',
  regulation: 'regulation',
  contractVehiclePlan: 'contractVehiclePlan',
  assignment: 'assignment',
  contractVehicleBudget: 'contractVehicleBudget',
};

/**
 * Тип документа сотрудника
 */
export const employeeDocumentTypeEnum = {
  rigger: 'rigger',
  lulechnik: 'lulechnik',
  safetyTechnician: 'safetyTechnician',
  safetyCarLift: 'safetyCarLift',
  controllerGpm: 'controllerGpm',
  manipulatorCranesOperator: 'manipulatorCranesOperator',
  truckCranesMachinist: 'truckCranesMachinist',
  carLiftOperator: 'carLiftOperator',
};

// Тип навесного оборудования
export const attachedEquipmentTypes = {
  ladle: 'Ковш',
  hydraulicHammer: 'Гидромолот',
  hydraulicShears: 'Гидроножницы',
  demolitionHammer: 'Бетонолом',
  multiprocessor: 'Мультипроцессор',
  grab: 'Грейфер',
  screwDrill: 'Шнековый бур',
  ripper: 'Рыхлитель',
  vibratoryPileDriver: 'Вибропогружатель',
  cutters: 'Фрезы',
  extraLong: 'Сверхдлинное навесное оборудование',
  mulcher: 'Мульчер',
  dozerBlade: 'Отвал бульдозерный',
  rotarySnowThrower: 'Снегоочиститель роторный',
  roadBrush: 'Щетка дорожная',
  sandSpreader: 'Разбрасыватель песка',
  plowThreeHingedMounted: 'Плуг трехкорпусный навесной',
  mountedDrillingRig: 'Навесная буровая установка',
  heater: 'Отопитель',
  preheater: 'Предпусковой подогреватель',
  generator: 'Генератор',
};

// Тип дополнительного оборудования
export const optionalEquipmentTypes = {
  tachograph: 'Тахограф',
  dashboardCamera: 'Видеорегистратор',
  sideUnit: 'Бортовой блок',
};

export const orderObjectives = {
  maintenance: 'Обслуживание',
  shipping: 'Перевозка груза',
  passengerTransportation: 'Перевозка пассажиров',
  repair: 'Аварийный ремонт',
  liftingWork: 'Грузоподъёмные работы',
};

export const authorizeTypes = {
  ldap: 'Авторизация пользователя по LDAP',
  standard: 'Стандартная авторизация',
};

export const authorizeTypeEnum = {
  ldap: 'ldap',
  standard: 'standard',
};

export const orderObjectivesEnum = {
  maintenance: 'maintenance',
  shipping: 'shipping',
  passengerTransportation: 'passengerTransportation',
  repair: 'repair',
  liftingWork: 'liftingWork',
};

export const orderTypes = {
  standard: 'Стандартная',
  // @deprecated данный тип является устаревшим
  additional: 'Дополнительная',
  emergency: 'Аварийная',
};

export const orderTypeEnum = {
  standard: 'standard',
  // @deprecated данный тип является устаревшим
  additional: 'additional',
  emergency: 'emergency',
};

export const driverStatuses = {
  free: 'Свободен',
  busy: 'Занят',
};

export const tripStatuses = {
  draft: 'Черновик',
  created: 'Создан',
  opened: 'Открыт',
  verification: 'Закрыт',
  verified: 'Оттаксирован',
  canceled: 'Отменен',
  contractorReview: 'На рассмотрении',
};

export const tripStatusEnum = {
  draft: 'draft',
  created: 'created',
  opened: 'opened',
  verification: 'verification',
  verified: 'verified',
  canceled: 'canceled',
  contractorReview: 'contractorReview',
};

export const orderStatusesForFilters = {
  created: 'Создана',
  approvingByMainEngineer: 'На подтверждении',
  onReworkGPM: 'На доработке (ГПМ)',
  approvedByMainEngineer: 'Утверждено',
  onReworkVehicle: 'На доработке (ТС)', // это не ошибка, в ТЗ для заявки ТС и заявки ГПМ статус для отправки на
                                        // доработку называется одинаково
  approved: 'Назначена',
  cancelled: 'Отменена',
  approvedByContractVehicleOrder: 'Назначена заявкой на доп. найм ТС',
};

export const orderStatuses = {
  created: 'Создана',
  approvingByMainEngineer: 'На подтверждении',
  onReworkGPM: 'На доработке',
  approvedByMainEngineer: 'Утверждено',
  onReworkVehicle: 'На доработке', // это не ошибка, в ТЗ для заявки ТС и заявки ГПМ статус для отправки на доработку
                                   // называется одинаково
  approved: 'Назначена',
  cancelled: 'Отменена',
  approvedByContractVehicleOrder: 'Назначена заявкой на доп. найм ТС',
};

export const orderStatusEnum = {
  created: 'created',
  approvingByMainEngineer: 'approvingByMainEngineer',
  onReworkGPM: 'onReworkGPM',
  approvedByMainEngineer: 'approvedByMainEngineer',
  onReworkVehicle: 'onReworkVehicle',
  approved: 'approved',
  cancelled: 'cancelled',
  approvedByContractVehicleOrder: 'approvedByContractVehicleOrder',
};

export const fuelAndOilView = {
  fuel: 'Топливо',
  lubricant: 'Смазки и масла',
  technicalFluid: 'Технические жидкости',
};

export const fuelAndOilViewEnum = {
  fuel: 'fuel',
  lubricant: 'lubricant',
  technicalFluid: 'technicalFluid',
};

export const fuelAndOilSubView = {
  diesel: 'Дизельное топливо',
  petrol: 'Бензин',
  gaseousFuel: 'Газобразное топливо',
  liquidOils: 'Масла жидкие',
  plasticLubricants: 'Смазки пластичные',
  coolingLiquid: 'Охлаждающие жидкости',
  brakeFluid: 'Тормозные жидкости',
  washingFluid: 'Промывочные жидкости',
  amortizationFluid: 'Амортизационные жидкости',
};

export const fuelAndOilSubViewEnum = {
  diesel: 'diesel',
  petrol: 'petrol',
  gaseousFuel: 'gaseousFuel',
  liquidOils: 'liquidOils',
  plasticLubricants: 'plasticLubricants',
  coolingLiquid: 'coolingLiquid',
  brakeFluid: 'brakeFluid',
  washingFluid: 'washingFluid',
  amortizationFluid: 'amortizationFluid',
};

export const fuelAndOilType = {
  motorOil: 'Моторные масла',
  transmissionOil: 'Трансмиссионные масла',
  industrialOil: 'Индустриальные масла',
  hydraulicOil: 'Гидравлические масла',
  lubricantsForConservation: 'Смазки консервационные',
  sealingLubricants: 'Смазки уплотнительные',
  antiGreaseLubricants: 'Антифракциооные смазки',
  tosol: 'Тосол',
  antifreeze: 'Антифриз',
  washingForEngineOilSystem: 'Промывка для маслянной системы двигателя',
};

export const fuelAndOilTypeEnum = {
  motorOil: 'motorOil',
  transmissionOil: 'transmissionOil',
  industrialOil: 'industrialOil',
  hydraulicOil: 'hydraulicOil',
  lubricantsForConservation: 'lubricantsForConservation',
  sealingLubricants: 'sealingLubricants',
  antiGreaseLubricants: 'antiGreaseLubricants',
  tosol: 'tosol',
  antifreeze: 'antifreeze',
  washingForEngineOilSystem: 'washingForEngineOilSystem',
};

export const fuelAndOilSubType = {
  oilForPetrolEngine: 'Моторные масла для бензиновых двигателей',
  oilForDieselEngine: 'Моторные масла для дизельных двигателей',
  fluidForGur: 'Жидкость для ГУРа',
};

export const fuelAndOilSubTypeEnum = {
  oilForPetrolEngine: 'oilForPetrolEngine',
  oilForDieselEngine: 'oilForDieselEngine',
  fluidForGur: 'fluidForGur',
};

export const fuelAndOilGroup = {
  summerDieselFuel: 'Дизельное топливо летнее',
  winterDieselFuel: 'Дизельное топливо зимнее',
  ai76: 'АИ-76',
  ai92: 'АИ-92',
  ai95: 'АИ-95',
  propaneButane: 'Пропан-Бутан',
  methane: 'Метан',
  mineralOil: 'Минеральное масло',
  semisyntheticOil: 'Полусинтетическое',
  synthetic: 'Синтетическое',
  shrus: 'Шрус',
  litol: 'Литол',
  am: 'АМ',
  a40m: 'А-40М',
  a65m: 'А65М',
  antifreezeGreen: 'Антифриз зеленый G11',
  antifreezeRed: 'Антифриз красный G12',
  antifreezeViolet: 'Антифриз фиолетовый G12++',
  dot2: 'DOT-2',
  dot3: 'DOT-3',
  dot4: 'DOT-4',
  dot5: 'DOT-5',
  fullVolume: 'Полнообъёмное',
  fiveMinute: '5-минутка',
  azh12t: 'АЖ-12т',
};

export const fuelAndOilGroupEnum = {
  summerDieselFuel: 'summerDieselFuel',
  winterDieselFuel: 'winterDieselFuel',
  ai76: 'ai76',
  ai92: 'ai92',
  ai95: 'ai95',
  propaneButane: 'propaneButane',
  methane: 'methane',
  mineralOil: 'mineralOil',
  semisyntheticOil: 'semisyntheticOil',
  synthetic: 'synthetic',
  shrus: 'shrus',
  litol: 'litol',
  am: 'am',
  a40m: 'a40m',
  a65m: 'a65m',
  antifreezeGreen: 'antifreezeGreen',
  antifreezeRed: 'antifreezeRed',
  antifreezeViolet: 'antifreezeViolet',
  dot2: 'dot2',
  dot3: 'dot3',
  dot4: 'dot4',
  dot5: 'dot5',
  fullVolume: 'fullVolume',
  fiveMinute: 'fiveMinute',
  azh12t: 'azh12t',
};

export const oilUnitsOfMeasurementFromParusTranslit = {
  kg: 'кг',
  l: 'л',
  pcs: 'шт',
};

export const waypointTypeEnum = {
  // Начальная точка
  start: 'start',
  // Промежуточная точка
  transit: 'transit',
  // Конечная точка
  end: 'end',
};

export const insuranceClasses = {
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5,
  sixth: 6,
  seventh: 7,
  eighth: 8,
  ninth: 9,
  tenth: 10,
  eleventh: 11,
  twelfth: 12,
  thirteenth: 13,
};

export const repairPlanTypes = {
  planned: 'Плановый',
  unplanned: 'Внеплановый',
};

export const repairPlanEnum = {
  planned: 'planned',
  unplanned: 'unplanned',
};

export const medicOwnerTypes = {
  own: 'Собственные',
  hired: 'Наемные',
};

export const medicOwnerEnum = {
  own: 'own',
  hired: 'hired',
};

export const maintenanceTypes = {
  to1: 'ТО-1',
  to2: 'ТО-2',
  seasonTo: 'Сезонное ТО',
  seasonTo1: 'Сезонное ТО + ТО-1',
  replacementTire: 'Замена шин',
  replacementAkb: 'Замена АКБ',
  repairing: 'Ремонт',
};

export const maintenanceTypeEnum = {
  to1: 'to1',
  to2: 'to2',
  seasonTo: 'seasonTo',
  seasonTo1: 'seasonTo1',
  replacementTire: 'replacementTire',
  replacementAkb: 'replacementAkb',
  repairing: 'repairing',
};

export const serviceOrderTypes = {
  repair: 'Ремонт',
  washing: 'Мойка',
  pass: 'Пропуски',
  osago: 'ОСАГО',
  gpmVehicleInspection: 'ГПМ',
  inspection: 'Тех. осмотр',
};

export const washingStatusTypes = {
  scheduled: 'Выдан',
  done: 'Выполнено',
};

export const washingStatusEnum = {
  scheduled: 'scheduled',
  done: 'done',
};

export const washingTypeEnum = {
  body: 'body',
  interior: 'interior',
  engine: 'engine',
};

export const washingTypes = {
  body: 'Кузов',
  interior: 'Салон',
  engine: 'ДВС',
};

export const maintenanceStatusesTypes = {
  created: 'В работе',
  approved: 'Согласована',
  declined: 'Отклонен',
  createdDefectiveStatement: 'Создана предварительная дефектно-ресурсная ведомость',
  approvementDefectiveStatement:
    'Предварительная дефектно-ресурсная ведомость на согласовани',
  approvedDefectiveStatement: 'Согласована предварительная дефектно-ресурсная ведомость',
  declinedDefectiveStatement: 'Отклонена предварительная дефектно-ресурсная ведомость',
  createdDetailedDefectiveStatement: 'Создана детальная дефектно-ресурсная ведомость',
  approvementDetailedDefectiveStatement:
    'Детальная дефектно-ресурсная ведомость на согласовани',
  approvedDetailedDefectiveStatement:
    'Согласована детальная дефектно-ресурсная ведомость',
  declinedDetailedDefectiveStatement: 'Отклонена детальная дефектно-ресурсная ведомость',
  receivedDetailedDefectiveStatement: 'Получена детальная дефектно-ресурсная ведомость',
  receivedWorkOrder: 'Получен заказ-наряд',
  approvedWorkOrder: 'Согласован заказ-наряд',
  declinedWorkOrder: 'Отклонен заказ-наряд',
};

export const maintenanceStatusesEnum = {
  created: 'created',
  approved: 'approved',
  declined: 'declined',
  createdDefectiveStatement: 'createdDefectiveStatement',
  approvementDefectiveStatement: 'approvementDefectiveStatement',
  approvedDefectiveStatement: 'approvedDefectiveStatement',
  declinedDefectiveStatement: 'declinedDefectiveStatement',
  createdDetailedDefectiveStatement: 'createdDetailedDefectiveStatement',
  approvementDetailedDefectiveStatement:
    'approvementDetailedDefectiveStatement',
  approvedDetailedDefectiveStatement: 'approvedDetailedDefectiveStatement',
  declinedDetailedDefectiveStatement: 'declinedDetailedDefectiveStatement',
  receivedDetailedDefectiveStatement: 'receivedDetailedDefectiveStatement',
  receivedWorkOrder: 'receivedWorkOrder',
  approvedWorkOrder: 'approvedWorkOrder',
  declinedWorkOrder: 'declinedWorkOrder',
};

export const orderContractorTypes = {
  internal: 'Хоз. способ',
  contractor: 'Подрядчик',
};

export const orderContractorTypeEnum = {
  internal: 'internal',
  contractor: 'contractor',
};

export const operationType = {
  ...orderContractorTypes,
};

export const operationTypeEnum = {
  ...orderContractorTypeEnum,
};

export const vehicleIssueTypes = {
  tinWorks: 'Жестяные работы',
  weldingWorks: 'Сварочные работы',
  straightening: 'Выравнивание',
};

export const vehicleIssueTypeEnum = {
  tinWorks: 'tinWorks',
  weldingWorks: 'weldingWorks',
  straightening: 'straightening',
};

export const maintenanceOperationStatuses = {
  proposal: 'В ожидании',
  approved: 'Подтвержден',
  declined: 'Отклонен',
};

export type MaintenanceOperationStatus = $Keys<typeof maintenanceOperationStatuses>;

export const monitoringVehicleStatusesEnum = {
  active: 'active',
  nosignal: 'nosignal',
  nonactive: 'nonactive',
};

/**
 * Статус ТС в мониторинге
 */
export const monitoringVehicleStatuses = {
  active: 'Активный',
  nosignal: 'Нет сигнала',
  nonactive: 'Не активный',
};

export const monitoringVehicleStatesEnum = {
  stopped: 'stopped',
  inmove: 'inmove',
  undef: 'undefined',
};

/**
 * Состояние ТС в мониторинге
 */
export const monitoringVehicleStates = {
  stopped: 'Стоит',
  inmove: 'В движении',
  undef: 'Неизвестно',
};

export const briefingViews = {
  primary: 'Первичный',
  inWorkingPlace: 'На рабочем месте',
  repeat: 'Повторный',
  unscheduled: 'Внеплановый',
};

export const briefingViewEnum = {
  primary: 'primary',
  inWorkingPlace: 'inWorkingPlace',
  repeat: 'repeat',
  unscheduled: 'unscheduled',
};

export const trainingViews = {
  primary: 'Первичный',
  inWorkingPlace: 'На рабочем месте',
  repeat: 'Повторный',
  unscheduled: 'Внеплановый',
};

export const trainingViewEnum = {
  primary: 'primary',
  inWorkingPlace: 'inWorkingPlace',
  repeat: 'repeat',
  unscheduled: 'unscheduled',
};

export const certificationViewEnum = {
  primary: 'primary',
  inWorkingPlace: 'inWorkingPlace',
  repeat: 'repeat',
  unscheduled: 'unscheduled',
};

export const employeeCertificationViews = {
  primary: 'Первичный',
  inWorkingPlace: 'На рабочем месте',
  repeat: 'Повторный',
  unscheduled: 'Внеплановый',
};

export const loadUnloadTypes = {
  load: 'Погрузка',
  unload: 'Выгрузка',
};

export const loadUnloadTypeEnum = {
  load: 'load',
  unload: 'unload',
};

// Тип ТС для ОВБ (оперативной выездной бригады)
export const vehicleOvbTypes = {
  forEightHour: '8 ч', // выделение на 8 чаcов
  forTwelveHour: '12 ч', // выделение на 12 чаcов
  forWholeDay: '24 ч', // выделение на целый день (24 ч)
};

// Типы событий для топливной карты
export const fuelCardVehicleTypes = {
  installed: 'Привязка',
  removed: 'Отвязка',
};

// Принадлежность ТС
export const ownerTypes = {
  // Собственное
  self: 'self',
  // Наёмное
  contract: 'contract',
  // Лизинг
  leased: 'leased'
};

export const drivingLicenseCategories = {
  a: 'A',
  b: 'B',
  c: 'C',
  d: 'D',
  e: 'E',
  m: 'M',
};

export const drivingLicenseCategoryEnum = {
  a: 'a',
  b: 'b',
  c: 'c',
  d: 'd',
  e: 'e',
  m: 'm',
};

export const tractorDrivingLicenseCategories = {
  a11Tractor: 'A1 (I)',
  a22Tractor: 'A2 (II)',
  a33Tractor: 'A3 (III)',
  a34Tractor: 'A3 (IV)',
  bTractor: 'B',
  cTractor: 'C',
  dTractor: 'D',
  eTractor: 'E',
  fTractor: 'F',
};

export const tractorDrivingLicenseCategoryEnum = {
  a11Tractor: 'a11Tractor',
  a22Tractor: 'a22Tractor',
  a33Tractor: 'a33Tractor',
  a34Tractor: 'a34Tractor',
  bTractor: 'bTractor',
  cTractor: 'cTractor',
  dTractor: 'dTractor',
  eTractor: 'eTractor',
  fTractor: 'fTractor',
};

export const chassisConfigurations = {
  fourToTwo: '4х2',
  fourToFour: '4х4',
  sixToFour: '6х4',
  sixToSix: '6х6',
  eightToFour: '8х4',
  eightToSix: '8х6',
  eightToEight: '8х8',
};

export const nodeFilterTypeEnum = {
  onlySelf: 'onlySelf', // Только себя
  branchAndChildren: 'branchAndChildren', // Вышележащий филиал и нижележащие службы
  selfAndChildren: 'selfAndChildren', // Текущий филиал и нижележащие службы
  onlyBranch: 'onlyBranch', // Только филиал
};

export const tripTypeEnum = {
  income: 'income',
  archive: 'archive',
  contract: 'contract',
};

export const serviceOrderStatusEnum = {
  pending: 'pending',
  completed: 'completed',
  canceled: 'canceled',
};

export const engineTypes = {
  diesel: 'Дизельный',
  petrol: 'Бензиновый',
  methane: 'Метановый',
  electrical: 'Электрический',
  none: 'Отсутствует',
};

export const engineTypeEnum = {
  diesel: 'diesel',
  petrol: 'petrol',
  methane: 'methane',
  electrical: 'electrical',
  none: 'none',
};

// Типы масел в ремонте
export const maintenanceTypeOils = {
  motor: 'Моторное',
  transmission: 'Трансмиссионное',
  grease: 'Пластичные смазки',
  specialFluids: 'Спецжидкости',
};

export const maintenanceTypeOilsEnum = {
  motor: 'motor',
  transmission: 'transmission',
  grease: 'grease',
  specialFluids: 'specialFluids',
};

// Теги для файлов
export const fileTags = {
  album: 'Изображения',
  all: 'Файлы',
  mainDocs: 'Основные документы',
  osago: 'Полисы ОСАГО',
  repairActs: 'Акты ремонтов',
  tariff: 'Обоснование тарифа',
};

export const fileTagEnum = {
  album: 'album',
  all: 'all',
  mainDocs: 'mainDocs',
  osago: 'osago',
  repairActs: 'repairActs',
  tariff: 'tariff',
};

// Типы работ для видов ремонта
export const maintenanceTypeOfWork = {
  akb: 'С использованием акб',
  tire: 'С использованием шин',
  common: 'Обычный',
  changeOil: 'Замена масла',
  to1: 'ТО-1',
  to2: 'ТО-2',
  to3: 'ТО-3',
  seasonMaintenance: 'Сезонное ТО',
};

export const maintenanceTypeOfWorkEnum = {
  akb: 'akb',
  tire: 'tire',
  common: 'common',
  changeOil: 'changeOil',
  to1: 'to1',
  to2: 'to2',
  to3: 'to3',
  seasonMaintenance: 'seasonMaintenance',
};

// Теги для файлов ремонтов

export const maintenanceFileTagEnum = {
  replacementTire: 'replacementTire',
  replacementAkb: 'replacementAkb',
};

export const operationLimitTypes = {
  employee: 'Должность',
  orgUnit: 'Служба',
  ovb: 'ОВБ',
};

export const operationLimitTypeEnum = {
  employee: 'employee', // Должностные лица
  orgUnit: 'orgUnit', // Службы
  ovb: 'ovb', // ОВБ
};

// Агрегируемые поля лимита
export const operationLimitAggregationFieldsEnum = {
  hours: 'hours',
  hoursWeekend: 'hoursWeekend',
  distance: 'distance',
  distanceWeekend: 'distanceWeekend',
};

export const monthlyWashingPlanStatuses = {
  draft: 'Черновик',
  approvement: 'На согласовании',
  inWork: 'В работе',
};

export const monthlyWashingPlanStatusEnum = {
  draft: 'draft',
  approvement: 'approvement',
  inWork: 'inWork',
};

export const certificationAreas = {
  a1: 'A.1',
  b931: 'Б.9.31',
  b93: 'Б.9.3',
  b932: 'Б.9.32',
  b94: 'Б.9.4',
};

export const certificationAreaEnum = {
  a1: 'a1',
  b931: 'b931',
  b93: 'b93',
  b932: 'b932',
  b94: 'b94',
};

// Кварталы
export const quartersEnum = {
  first: ['январь', 'февраль', 'март'],
  second: ['апрель', 'май', 'июнь'],
  third: ['июль', 'август', 'сентябрь'],
  fourth: ['октябрь', 'ноябрь', 'декабрь'],
};

export const quarters = {
  first: '1-й квартал',
  second: '2-й квартал',
  third: '3-й квартал',
  fourth: '4-й квартал',
};

export const operationLimitGroupStatusEnum = {
  // Черновик
  draft: 'draft',
  // На согласовании
  onAgreeing: 'onAgreeing',
  // Утвержден
  approved: 'approved',
};

/**
 * Статусы расчетов полисов ОСАГО
 */
export const osagoCalculationStatusEnum = {
  draft: 'draft',
  onApproving: 'onApproving',
  approved: 'approved',
};

export const osagoCalculationStatuses = {
  draft: 'Черновик',
  onApproving: 'На утверждении',
  approved: 'Утвержден',
};

export const contractTripStatusEnum = {
  contractorReview: 'contractorReview',
  verified: 'verified',
  accepted: 'accepted',
  canceled: 'canceled',
};

export const contractTripStatuses = {
  contractorReview: 'На рассмотрении',
  verified: 'Согласован',
  accepted: 'Принят',
  canceled: 'Отменен',
};

export const newContractTripStatusEnum = {
  created: 'created',
  aproved: 'aproved',
  sended: 'sended',
  sendError: 'sendError',
  inSended: 'inSended',
  declined: 'declined',
};

export const newContractTripStatuses = {
  created: 'Создан',
  aproved: 'Утвержден',
  sended: 'Отправлен',
  sendError: 'Ошибка отправки',
  inSended: 'Отправка',
  declined: 'Отклонён',
};

export const regulationLimitTypes = {
  employee: 'Должность',
  orgUnit: 'Служба',
  ovb: 'ОВБ',
  oneOffRequests: 'Разовые заявки',
};

export const regulationLimitTypeEnum = {
  employee: 'employee', // Должностные лица
  orgUnit: 'orgUnit', // Службы
  ovb: 'ovb', // ОВБ
  oneOffRequests: 'oneOffRequests', // Разовые заявки
};

export const expenseDirectionTypes = {
  otherServices: 'Прочие услуги',
  carServices: 'Услуги легкового транспорта',
  otherVehicleServices: 'Прочие транспортные расходы',
  vehicleServicesFromProfit: 'Транспортные расходы из прибыли',
  acsVehicleServices: 'Услуги автотранспорта для ОКС',
  cargoServices: 'Услуги а/т со стороны по транспортировке грузов',
  mechanismServices: 'Услуги механизмов',
  provisionVehicleSecvices: 'Транспортно заготовительные расходы',
  battery: 'Потребность в АКБ',
  expertise: 'Потребность в экспертизе и ТО ПБ ГПМ',
  gps: 'Потребность в GPS-Навигации',
  measuringDeviceCertification: 'Потребность в тарировке цистерн',
  gtnTax: 'Потребность в ТО Гостехнадзор (пошлина)',
  gtnWork: 'Потребность в ТО Гостехнадзор (работа)',
  gibdd: 'Потребность в ТО ГИБДД',
  pass: 'Пропуска',
  passTax: 'Пропуска (госпошлина)',
  licensePlateChange: 'Потребность в замене гос.номеров',
  materials: 'Потребность в инструментах, материалах',
  federalHighway: 'Плата за проезд по федеральным трассам (ПЛАТОН)',
  washing: 'Потребность в мойке',
  driverInspection: 'Потребность в предрейсовых/послерейсовых осмотрах',
  petrol: 'Потребность в бензине (АИ-80,92,95)',
  currentRepair: 'Текущий ремонт СТС',
  overhaul: 'Капитальный ремонт СТС',
  dieselFuel: 'Потребность в ДТ',
  tires: 'Потребность в автошинах',
  maintenance: 'Потребность в тех.обслуживании',
  aviation: 'Авиационные услуги',
  helicopter: 'Услуги вертолета',
  notarial: 'Нотариальные действия',
  vehicleTax: 'Транспортный налог',
  osago: 'Страхование ТС',
  oilsAndGreases: 'Потребность в маслах и смазках',
};

export const expenseDirectionTypeEnum = {
  otherServices: 'otherServices',
  carServices: 'carServices',
  otherVehicleServices: 'otherVehicleServices',
  vehicleServicesFromProfit: 'vehicleServicesFromProfit',
  acsVehicleServices: 'acsVehicleServices',
  cargoServices: 'cargoServices',
  mechanismServices: 'mechanismServices',
  provisionVehicleSecvices: 'provisionVehicleSecvices',
  battery: 'battery',
  expertise: 'expertise',
  gps: 'gps',
  measuringDeviceCertification: 'measuringDeviceCertification',
  gtnTax: 'gtnTax',
  gtnWork: 'gtnWork',
  gibdd: 'gibdd',
  pass: 'pass',
  passTax: 'passTax',
  licensePlateChange: 'licensePlateChange',
  materials: 'materials',
  federalHighway: 'federalHighway',
  washing: 'washing',
  driverInspection: 'driverInspection',
  petrol: 'petrol',
  currentRepair: 'currentRepair',
  overhaul: 'overhaul',
  dieselFuel: 'dieselFuel',
  tires: 'tires',
  maintenance: 'maintenance',
  aviation: 'aviation',
  helicopter: 'helicopter',
  notarial: 'notarial',
  vehicleTax: 'vehicleTax',
  osago: 'osago',
  oilsAndGreases: 'oilsAndGreases',
};

export const workHourPriceEnum = {
  contractMethod: 'contractMethod',
  contractMethodOnTheGo: 'contractMethodOnTheGo',
  economicMethod: 'economicMethod',
};

export const workHourPriceTypes = {
  contractMethod: 'Подрядный метод',
  contractMethodOnTheGo: 'Подрядный метод с выездом подрядчика',
  economicMethod: 'Хоз. способ',
};

export const STSEnum = {
  exploited: 'exploited',
  forBudget: 'forBudget',
};

export const STSTypes = {
  exploited: 'В эксплутации',
  forBudget: 'Для бюджета',
};

export const orderDispatcherTypes = {
  all: 'Все заявки',
  self: 'Мои заявки',
};

export const tripsDispatcherTypes = {
  self: 'Мои ПЛ',
  all: 'Все ПЛ',
};

export const approveEnum = {
  approved: 'approved',
  notApproved: 'notApproved',
};

export const approveTypes = {
  approved: 'Утвержден',
  notApproved: 'Не утвержден',
};

export const pseudoNameEnum = {
  main: 'main',
  approvedOnBk: 'approvedOnBk',
  approvedOnBkf: 'approvedOnBkf',
};

export const pseudoNameTypes = {
  main: 'Основной',
  approvedOnBk: 'Утвержденный на БК',
  approvedOnBkf: 'Утвержденный на БКФ',
};

export const monthsNumbersEnum = {
  1: 'january',
  2: 'february',
  3: 'march',
  4: 'april',
  5: 'may',
  6: 'june',
  7: 'july',
  8: 'august',
  9: 'september',
  10: 'october',
  11: 'november',
  12: 'december',
};

export const monthsEnum = {
  january: 'january',
  february: 'february',
  march: 'march',
  april: 'april',
  may: 'may',
  june: 'june',
  july: 'july',
  august: 'august',
  september: 'september',
  october: 'october',
  november: 'november',
  december: 'december',
};

export const monthsNamesTranslitEnum = {
  january: 'Январь',
  february: 'Февраль',
  march: 'Март',
  april: 'Апрель',
  may: 'Май',
  june: 'Июнь',
  july: 'Июль',
  august: 'Август',
  september: 'Сентябрь',
  october: 'Октябрь',
  november: 'Ноябрь',
  december: 'Декабрь',
};

export const budgetSummaryStatusEnum = {
  created: 'created',
  approvement: 'approvement',
  approved: 'approved',
  declined: 'declined',
};

export const budgetSummaryStatus = {
  created: 'Черновик',
  approvement: 'На утверждении',
  approved: 'Утвержден',
  declined: 'Отклонен',
};

export const budgetSummaryEnum = {
  main: 'main',
  clarification: 'clarification',
};

export const budgetSummary = {
  main: 'Основной',
  clarification: 'Уточнение',
};

export const budgetLineItemBudgetEnum = {
  costFromProfit: 'costFromProfit',
  estimate: 'estimate',
  repair: 'repair',
  stocksAndPurchases: 'stocksAndPurchases',
};

export const budgetLineItemBudget = {
  costFromProfit: 'Расходы из прибыли',
  estimate: 'Смета затрат',
  repair: 'Расходы на ремонт(СМКТР)',
  stocksAndPurchases: 'Бюджет запасов и покупок',
};
// Необходимо для склонения "Итого по "
export const budgetLineItemBudgetInline = {
  costFromProfit: 'расходам из прибыли',
  estimate: 'смете затрат',
  repair: 'расходам на ремонт(СМКТР)',
  stocksAndPurchases: 'бюджету запасов и покупок',
};

export const branchBudgetSummaryExpenseDirectionTypeEnum = {
  common: 'common',
  estimate: 'estimate',
  display: 'display',
};

export const ISUBudgetingData = {
  activityDirection: 'Направление деятельности',
  itemOfCalculation: 'Статья калькуляции',
  specialMark: 'Особая отметка',
  typeOfMovementByElement: 'Вид движения по элементу',
};

export const ISUBudgetingDataTypeEnum = {
  activityDirection: 'activityDirection',
  itemOfCalculation: 'itemOfCalculation',
  specialMark: 'specialMark',
  typeOfMovementByElement: 'typeOfMovementByElement',
  isuBudgetingDataId: 'isuBudgetingDataId',
};

export const cognosContractMonthEnum = {
  currentYear: 'currentYear',
  pastYear: 'pastYear',
  nextYear: 'nextYear',
};

export const taxRates = {
  zero: '0%',
  five: '5%',
  ten: '10%',
  twenty: '20%',
  twentyTwo: '22%',
};

export const taxRatesEnum = {
  zero: 'zero',
  five: 'five',
  ten: 'ten',
  twenty: 'twenty',
  twentyTwo: 'twentyTwo',
};

export const cognosLogStatus = {
  sending: 'Отправка',
  mapping: 'Маппирование',
  mappingFinished: 'Без ошибок (маппирование завершено)',
  error: 'Ошибка',
  mappingFinishedAndStatusGot: 'Маппинг завершен, получен ответ от когноса',
  finished: 'Получен статус о подтвержении бюджета',
  sended: 'Данные успешно отправлены',
};

export const cognosLogStatusEnum = {
  sending: 'sending',
  mapping: 'mapping',
  mappingFinished: 'mappingFinished',
  error: 'error',
  mappingFinishedAndStatusGot: 'mappingFinishedAndStatusGot',
  finished: 'finished',
  sended: 'sended',
};

export const branchBudgetSummaryCognosStatus = {
  notProcessed: 'Не отправлен',
  approved: 'Утвержден',
  partiallyApproved: 'Утверждены не все направления',
  declined: 'Отклонен',
  sended: 'Отправлен',
  approving: 'Ожидает утверждения',
  error: 'Ошибка',
};

export const cognosSendingStatuses = {
  error: 'Ошибка',
  send: 'Отправлено',
  notSend: 'Не отправлено',
};

export const cognosSendingStatusEnum = {
  error: 'error',
  send: 'send',
  notSend: 'notSend',
  notNecessary: 'notNecessary',
};

export const branchBudgetSummaryCognosStatusEnum = {
  notProcessed: 'notProcessed',
  approved: 'approved',
  partiallyApproved: 'partiallyApproved',
  declined: 'declined',
  sended: 'sended',
  approving: 'approving',
  error: 'error',
};

export const branchBudgetSummaryCognosTypeEnum = {
  primary: 'primary',
  cognos: 'cognos',
  corrected: 'corrected',
};

export const expenseDirectionCognosStatus = {
  error: 'Ошибка при обработке запроса',
  notProcessed: 'Направление расходов еще не обработано',
  approved: 'Направление расходов утверждено',
  declined: 'Направление расходов отклонено',
};

export const expenseDirectionCognosStatusEnum = {
  error: 'error',
  notProcessed: 'notProcessed',
  approved: 'approved',
  declined: 'declined',
};

export const cognosContractStatusEnum = {
  ...entityStatusEnum,
};

export const oilConsumptionStatusEnum = {
  notRecieved: 'notRecieved',
  recivied: 'recivied',
  error: 'error',
  calculationDone: 'calculationDone',
};

export const oilConsumptionStatuses = {
  notRecieved: 'Ожидаются данные из системы "Парус"',
  recivied: 'Получены данные из системы "Парус"',
  error: 'Ошибка получения данных из системы "Парус"',
  calculationDone: 'Данные учтены в документе "Фактический расчёт ГСМ"',
};

export const inspectionTypes = {
  gibdd: 'gibdd',
  gtn: 'gtn',
};

export const inspectionTypesEnum = {
  gibdd: 'Учитывать в затратах ТО ГИБДД',
  gtn: 'Учитывать в затратах Гостехнадзор',
};

export const contractStatusEnum = {
  expensesEditing: 'expensesEditing',
  coefEditing: 'coefEditing',
  approved: 'approved',
};

export const vehicleItemHistoryTypeEnum = {
  installed: 'Установка',
  removed: 'Снятие',
  decommissioned: 'Списание',
};

export const materialsMtoStatus = {
  notSend: 'Не отправлен',
  sended: 'Отправлен',
  error: 'Ошибка',
  неСогласован: 'Не согласован',
  новый: 'Новый',
  вРаботе: 'В работе',
  согласован: 'Согласован',
};

export const materialsMtoStatusEnum = {
  notSend: 'notSend',
  sended: 'sended',
  error: 'error',
  неСогласован: 'неСогласован',
  новый: 'новый',
  вРаботе: 'вРаботе',
  согласован: 'согласован',
}

export const leasers = {
  energotrans: 'Энерготранс',
  kts: 'КТС',
};
